import(/* webpackMode: "eager" */ "/codebuild/output/src1770442113/src/telemedicina-meet/app/page.tsx");
